// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const SubProductCodeApprvService = {};

SubProductCodeApprvService.getSubProductCodeApprvList = function (userInput) {
  return lossClient({
    url: "/SubProductType/approvalItems?pageSize=1000&pageIndex=0",
    method: "get",
  });
};

export default SubProductCodeApprvService;
